/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tag: NonNullable<unknown> }} Iconik_Metadata_Tag_RemoveInputs */

const en_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const fr_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const de_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const it_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const ru_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const es_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const zh_cn2_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const ja_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const hi_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

const pt_pt2_iconik_metadata_tag_remove = /** @type {(inputs: Iconik_Metadata_Tag_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.tag}`)
};

/**
* | output |
* | --- |
* | "Remove {tag}" |
*
* @param {Iconik_Metadata_Tag_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_tag_remove = /** @type {((inputs: Iconik_Metadata_Tag_RemoveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Tag_RemoveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_metadata_tag_remove(inputs)
	if (locale === "de") return de_iconik_metadata_tag_remove(inputs)
	if (locale === "it") return it_iconik_metadata_tag_remove(inputs)
	if (locale === "ru") return ru_iconik_metadata_tag_remove(inputs)
	if (locale === "es") return es_iconik_metadata_tag_remove(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_metadata_tag_remove(inputs)
	if (locale === "ja") return ja_iconik_metadata_tag_remove(inputs)
	if (locale === "hi") return hi_iconik_metadata_tag_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_metadata_tag_remove(inputs)
	return en_iconik_metadata_tag_remove(inputs)
});